// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

import wixLocation from 'wix-location';
import wixUsers from 'wix-users';
import { currentMember } from 'wix-members';

$w.onReady(function () {
    $w('#productPage1').getProduct()
        .then((product) => {
            let user = wixUsers.currentUser;

            if (user.loggedIn) {
                currentMember.getRoles()
                    .then((roles) => {
                        if (roles.length != 0) {
                            wixLocation.to('/products/' + product.slug);
                        } else {
                            $w('#productPage1').show()
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            } else {
                $w('#productPage1').show()
            }
            // see example product object below
        })
        .catch((error) => {
            console.error(error);
        });

    // Write your Javascript code here using the Velo framework API

    // Print hello world:
    // console.log("Hello world!");

    // Call functions on page elements, e.g.:
    // $w("#button1").label = "Click me!";

    // Click "Run", or Preview your site, to execute your code

});